angular.module('CarsSaraBo').controller('ReviewsController', ['$scope', 'ReviewsService', '$routeParams', '$q', '$translate', 'DateService', 'ReviewGAConfig',
	'InformationModalService', 'CompanyService', 'BookingService', 'NotificationService', 'LoadingWheelService','$cookies',
	function ($scope, reviewsService, $routeParams, $q, $translate, dateService, reviewGAConfig,
			  informationModalService, companyService, bookingService, notificationService, loadingWheelService, $cookies) {

        var VALID_PERIOD_LENGTH = 2.0; //expressed in years
		var REVIEWS_NEWS_READ = "reviews_news_read";
        var modalExpirationdays = 15;
		var gaReview = reviewGAConfig.reviewGa();
		const SEND_RESPONSE = 'Enviar_respuesta_comentario';
		const CANCEL_SEND_RESPONSE = 'Cancelar_respuesta_comentario';

        function initialize() {
			informationModalService.setInformationModalData({
                title: 'review.HOW_DOES_IT_WORKS',
                groupText: [{
                    texts: ['review.modal.TEXT_A', 'review.modal.TEXT_B', 'review.modal.TEXT_C', 'review.modal.TEXT_D', 'review.modal.TEXT_E', 'review.modal.TEXT_F']
                }]
			});
			gaReview.send("Page_view");
			$scope.showProgressBar();
			$scope.loader = false;
			setPage({itemsPerPage: 20, currentPage: 1, numPages: 0,	items: []});

			$scope.metadata = {
				companyDestinations: [],
				scores: [],
				sortingCriteria: []
			};

			var defaultToDate = new Date();
			var defaultFromDate = new Date();
			defaultFromDate.setYear(defaultToDate.getFullYear() - VALID_PERIOD_LENGTH);

			$scope.appliedFilter = {
				destination: "",
				dateRange: {
					from:defaultFromDate,
					to: defaultToDate
				},
				evaluation: ""
			};
			// input de review-filter-directive.
			$scope.reviewFilterObject = angular.copy($scope.appliedFilter);

			$scope.fenixOid;
			$scope.sorting = "";

			$scope.companyOid = $routeParams.companyOid;
			$scope.infiniteDisabled = true;

			$scope.reviews = [];
            $scope.errorField = {};
			fetchInitialData();
			showNewsModal();
		}

        function showNewsModal(){
			var modalReviewsNews = $cookies.get(REVIEWS_NEWS_READ);
			if (!modalReviewsNews) {
				$cookies.put(REVIEWS_NEWS_READ, 'true', $scope.getExpirationDateModal());
				showModal();
			}else if(modalReviewsNews === 'true'){
				showModal();

			}
        }

		$scope.closeModal = function (understood) {
			if(understood){
				$cookies.put(REVIEWS_NEWS_READ, 'false');
			}
			hideModal();
		}

		function showModal(){
			document.getElementById("newsModal").className += ' -show-modal';
		}

		function hideModal() {
			document.getElementById("newsModal").classList.remove("-show-modal");
		}

		$scope.showIt = function () {
			informationModalService.showInformationModal();
		}

		$scope.clearToastError = function () {
			notificationService.toastVisible = false;
		}

		$scope.getExpirationDateModal = function(){
            var date = new Date();
            date.setDate(date.getDate() + modalExpirationdays);
            return {expires: date};
        }

		function setTitle(title) {
			$scope.title = title;
		}

		function fetchInitialData() {
			$scope.noReviews = false;
			var fieldsCompany = "tradeName";

			$q.all([
				reviewsService.fetchSummary($scope.companyOid),
				reviewsService.fetchPage($scope.companyOid, {pageNumber: 1, itemsPerPage: 30}, buildFilter($scope.appliedFilter, $scope.sorting)),
				reviewsService.fetchDestinations($scope.companyOid),
				reviewsService.fetchScores($scope.companyOid),
				reviewsService.fetchSortingCriteria($scope.companyOid),
				companyService.get({oid: $scope.companyOid}).$promise
			]).then(function (response) {
				$scope.summary = response[0];
				setPage(response[1]);
				$scope.reviews = response[1].items;
				if ($scope.reviews.length == 0) {
					$scope.noReviews = true;
				}
				$scope.metadata.companyDestinations = response[2];
				$scope.metadata.scores = response[3];
				$scope.metadata.sortingCriteria = response[4];
				$scope.companyName = response[5].tradeName;
				setTitle($scope.companyName);

				$scope.infiniteDisabled = false;
				$scope.hideProgressBar();
			});
		}

		function setPage(page) {
			$scope.pagination = {
				itemsPerPage: page.itemsPerPage,
				currentPage: page.currentPage,
				items: page.items
			};
		}

		function buildFilter(filters, sorting) {
			var filter = {
				evaluation: filters.evaluation,
				destination: !filters.destination ? "" : filters.destination.iataCode,
				dateFrom: !filters.dateRange ? "" : dateService.customFormatDate(filters.dateRange.from, "yyyyMMdd"),
				dateTo: !filters.dateRange ? "" : dateService.customFormatDate(filters.dateRange.to, "yyyyMMdd"),
				sorting: sorting
			}
			return filter;
		}

		$scope.showDetail = function(fenixOid){
            var bookingFilter = {};
            bookingFilter.fenixOID = fenixOid;
            bookingService.queryPage(bookingFilter, {"companyOID": $scope.companyOid},function(result) {
            	//analytics
            	if (result.items.length == 1){
					var oid = result.items[0].oid;
                    gaReview.send("Click_ID", fenixOid);
                    window.open("./company/" + $scope.companyOid + "/booking/" + oid, "_blank");
				}else{
                    notificationService.notifyErrorByCode('common.ERROR_500');
					var error = new Error("La review con fenixOid " +  fenixOid + " no puede ser asociada a un bookingOid");
                    window.NREUM.noticeError(error);
				}
			});
		}

		$scope.applyFilters = function (filter) {
			$scope.infiniteDisabled = false;
			var hasLocationChange = (filter.destination != "" && $scope.appliedFilter.destination != ""
				&& filter.destination.locationOid != $scope.appliedFilter.destination.locationOid) || (filter.destination != "" && !$scope.appliedFilter.destination)
				|| (!filter.destination && $scope.appliedFilter.destination != "" )
			if (filter) {
				$scope.appliedFilter = angular.copy(filter);
			}
			$scope.apply($scope.appliedFilter, hasLocationChange);
		}

		$scope.apply = function (filter, changeLocation) {
			$scope.showProgressBar();
			if (!changeLocation) {
				fetchReviews({pageNumber: 1, itemsPerPage: 30}, fetchReviewsCallback);
			} else {
				fetchSummary((!filter.destination) ? "" : filter.destination.locationOid)
				fetchReviews({pageNumber: 1, itemsPerPage: 30}, fetchReviewsCallback);
				setTitle((!filter.destination) ? $scope.companyName : filter.destination.name);
			}
		}

		function fetchSummary(destination) {
			reviewsService.fetchSummary($scope.companyOid, destination).then(function (response) {
				$scope.summary = response;
			})
		}

		function fetchReviews(page, callback) {
			reviewsService.fetchPage($scope.companyOid, page, buildFilter($scope.appliedFilter, $scope.sorting)).then(callback);
		}

		function fetchReviewsCallback(response) {
			setPage(response)
			$scope.reviews = response.items;
			$scope.hideProgressBar();
		}

		function fetchInfiniteCallback(response) {
			setPage(response)
			if (response.items.length > 0) {
				$scope.reviews = $scope.reviews.concat(response.items);
				$scope.infiniteDisabled = false;
			}
			$scope.loader = false;
		}

		$scope.loadMore = function () {
			$scope.loader = true;
			$scope.infiniteDisabled = true;
			gaReview.send("Ir_a_pagina", $scope.pagination);
			fetchReviews({pageNumber: $scope.pagination.currentPage + 1, itemsPerPage: $scope.pagination.itemsPerPage}, fetchInfiniteCallback);
		}

		$scope.trackGA = function (event, category) {
			gaReview.send(event, category);
		};

        $scope.exportToExcel = function (appliedFilters, sorting) {
        	if(isValidPeriodFilter(appliedFilters.dateRange)) {
                loadingWheelService.show();
                var filter = buildFilter(appliedFilters, sorting);
                reviewsService.exportToExcel($scope.companyOid, filter)
                    .finally(function () {
                        loadingWheelService.hide();
                    });
                gaReview.send("Exportar", "Excel");
            }
        };

        $scope.cancelSendResponseGA = function () {
			gaReview.send(CANCEL_SEND_RESPONSE);
		};

		$scope.sendResponseGA = function () {
			gaReview.send(SEND_RESPONSE);
		};

        function isValidPeriodFilter(dateRange) {
        	var isValid = true;
        	if(!!dateRange && !!dateRange.from && !!dateRange.to) {
        		var from = moment(dateRange.from);
        		var to = moment(dateRange.to);
        		if(to.diff(from, "years", true) > VALID_PERIOD_LENGTH) {
        			isValid = false;
        			$scope.errorField["reviewsDateRange"] = "input-error";
                    notificationService.notifyErrorByCode("review.download.tooLongPeriod");
				}
			}
        	return isValid;
		}

		initialize();

	}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/reviews_controller.js
// module id = 907
// module chunks = 3